import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Header from '../../components/Header/Header';
import SnackBar from '../../components/SnackBar/SnackBar';
import SubmitButton from '../../components/SubmitButton/SubmitButton';

import Logo from '../../assets/svgs/Logo';
import registerIllustration from '../../assets/images/healthscan-register-illustration.svg';

import Api from '../../libs/Api';
import translate from '../../libs/i18n';
import onlyNumbers from '../../utils/onlyNumbers';

import { NoInstitutionStyle } from './NoInstitutionStyle';
import Button from '../../components/Button/Button';

const NoInstitution = () => {
  const codeRefs = useRef([]);
  const history = useHistory();
  const language = useSelector((state) => state.settings.language);
  const { token } = useParams();

  const [code0, setCode0] = useState('');
  const [code1, setCode1] = useState('');
  const [code2, setCode2] = useState('');
  const [code3, setCode3] = useState('');
  const [code4, setCode4] = useState('');
  const [code5, setCode5] = useState('');
  const [emailConfirmationWarning, setEmailConfirmationWarning] = useState({
    type: '',
    text: '',
  });
  const [mainError, setMainError] = useState('');

  const hasEmailConfirmationSuccess = useMemo(
    () =>
      emailConfirmationWarning &&
      emailConfirmationWarning.type &&
      emailConfirmationWarning.type === 'success',
    [emailConfirmationWarning]
  );

  const hasEmailConfirmationError = useMemo(
    () =>
      emailConfirmationWarning &&
      emailConfirmationWarning.type &&
      emailConfirmationWarning.type === 'error',
    [emailConfirmationWarning]
  );

  const hasEmailConfirmationWarning = useMemo(
    () => hasEmailConfirmationSuccess || hasEmailConfirmationError,
    [hasEmailConfirmationError, hasEmailConfirmationSuccess]
  );

  useEffect(() => {
    if (token && token.length) {
      if (token.length >= 1) {
        setCode0(token[0]);
      }

      if (token.length >= 2) {
        setCode1(token[1]);
      }

      if (token.length >= 3) {
        setCode2(token[2]);
      }

      if (token.length >= 4) {
        setCode3(token[3]);
      }

      if (token.length >= 5) {
        setCode4(token[4]);
      }

      if (token.length >= 6) {
        setCode5(token[5]);
      }
    }
  }, [token]);

  useEffect(() => {
    if (hasEmailConfirmationWarning) {
      const timeout = setTimeout(() => {
        setEmailConfirmationWarning(null);

        if (hasEmailConfirmationSuccess) {
          history.push('/entrar');
        }
      }, 3500);

      return () => clearTimeout(timeout);
    }

    return null;
  }, [hasEmailConfirmationSuccess, hasEmailConfirmationWarning, history]);

  const changeFocus = (index) => {
    if (index >= 0 && index <= 5) {
      setTimeout(() => codeRefs.current[index].focus(), 25);
    }
  };

  const updateCodeValueByIndex = (value, index) => {
    if (value && value.length) {
      changeFocus(index + 1);
    }

    switch (index) {
      case 0:
        setCode0(value);
        break;

      case 1:
        setCode1(value);
        break;

      case 2:
        setCode2(value);
        break;

      case 3:
        setCode3(value);
        break;

      case 4:
        setCode4(value);
        break;

      case 5:
        setCode5(value);
        break;

      default:
        break;
    }
  };

  const handleChangeCode = (event, index) => {
    const value = onlyNumbers(event.currentTarget.value);

    if (value.length <= 1) {
      updateCodeValueByIndex(value, index);
    } else if (value.length > 1) {
      let n = 0;

      for (let i = index; i < 6; i += 1) {
        updateCodeValueByIndex(value[n], i);

        n += 1;
      }
    }
  };

  const handleKeyDown = (event, index, value) => {
    if (event.keyCode === 8 && value === '') {
      changeFocus(index - 1);
    }
  };

  const handleSubmitCode = async (event) => {
    event.preventDefault();

    const completeCode = `${code0}${code1}${code2}${code3}${code4}${code5}`;

    if (!completeCode || (completeCode && completeCode.length !== 6)) {
      setMainError('Código inválido');
    } else {
      setMainError('');

      const response = await Api.finishRegistration({ token: completeCode });

      if (response && response.status && response.status === 200) {
        setEmailConfirmationWarning({
          type: 'success',
          text: translate('emailConfirmedSuccessfully', language),
        });
      } else {
        setEmailConfirmationWarning({
          type: 'error',
          text: translate('errorConfirmingEmail', language),
        });
      }
    }
  };

  return (
    <NoInstitutionStyle>
      <Header />
      <div className="email-confirmation-content">
        <section className="image-section">
          <div className="logo-wrapper">
            <Logo theme="white" />
          </div>
          <img
            className="register-illustration"
            src={registerIllustration}
            alt="Register illustration"
          />
        </section>
        <section className="form-section">
          <div className="form-content">
            <div className="form-head">
              <h1 className="form-head-title">
                {translate('waitingAuthorization', language)}
              </h1>
              <p className="form-head-description">
                {`${translate('noInstutionBodyInfo', language)}.`}
              </p>
              <Button
                    type="button"
                    theme="default"
                    onClick={Api.handLeogout}
                    text="Logout"
                    />

            </div>

          </div>
        </section>
      </div>
      {hasEmailConfirmationWarning ? (
        <div className="snack-bar-wrapper">
          <SnackBar
            type={emailConfirmationWarning.type}
            text={emailConfirmationWarning.text}
          />
        </div>
      ) : null}
    </NoInstitutionStyle>
  );
};

export default NoInstitution;
